const TRANSFER_INTERVAL_TYPE_DAILY_ENUM = {
  struct: {
    DIARIO: 'diário',
    DAILY: 'daily'
  },
  label: 'Daily'
}

const TRANSFER_INTERVAL_TYPE_WEEKLY_ENUM = {
  struct: {
    SEMANAL: 'semanal',
    WEEKLY: 'weekly'
  },
  label: 'Weekly'
}

const TRANSFER_INTERVAL_TYPE_MONTHLY_ENUM = {
  struct: {
    MENSAL: 'mensal',
    MONTHLY: 'monthly'
  },
  label: 'Monthly'
}

const TRANSFER_INTERVAL_TYPE_ENUM = {
  DAILY: TRANSFER_INTERVAL_TYPE_DAILY_ENUM,
  WEEKLY: TRANSFER_INTERVAL_TYPE_WEEKLY_ENUM,
  MONTHLY: TRANSFER_INTERVAL_TYPE_MONTHLY_ENUM
}

const isTransferIntervalTypeDaily = type =>
  Object.values(TRANSFER_INTERVAL_TYPE_ENUM.DAILY.struct).includes(
    type?.toLowerCase()
  )

const isTransferIntervalTypeWeekly = type =>
  Object.values(TRANSFER_INTERVAL_TYPE_ENUM.WEEKLY.struct).includes(
    type?.toLowerCase()
  )

const isTransferIntervalTypeMonthly = type =>
  Object.values(TRANSFER_INTERVAL_TYPE_ENUM.MONTHLY.struct).includes(
    type?.toLowerCase()
  )

export {
  TRANSFER_INTERVAL_TYPE_ENUM,
  TRANSFER_INTERVAL_TYPE_DAILY_ENUM,
  TRANSFER_INTERVAL_TYPE_WEEKLY_ENUM,
  TRANSFER_INTERVAL_TYPE_MONTHLY_ENUM,
  isTransferIntervalTypeDaily,
  isTransferIntervalTypeWeekly,
  isTransferIntervalTypeMonthly
}
